import type { Context } from 'react';
import { createContext, useContext } from 'react';

export const VisibilityObserverRootContext: Context<HTMLElement | null> = createContext<HTMLElement | null>(null);

export type UseVisibilityObserverRootContext = () => HTMLElement | null;
export const useVisibilityObserverRootContext: UseVisibilityObserverRootContext = () =>
  useContext(VisibilityObserverRootContext);
